export function getBillingColumnKey(column) {
    if (!column) return null
    return column.accessorKey ?? column.accessorkey ?? null
}

export function isLoanBillingColumn(column) {
    const key = String(getBillingColumnKey(column) || '')
    const header = String(column?.header || '')
    return /loan/i.test(key) || /\bloan\b/i.test(header)
}

export function getDefaultBillingColumnKeys(columns = []) {
    return columns
        .filter((column) => !isLoanBillingColumn(column))
        .map((column) => getBillingColumnKey(column))
        .filter(Boolean)
}
